import React, { useState,useEffect } from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; 
import CommonAPI from '../../Common/CommonAPI';
import SuccessMSG from "../../Common/SuccessMsg"
var api = require('../../Common/Config');

function  DailyTransferLimit (props)  {

  const [FromAccountList,setFromAccountList] = useState([]);
  const [SelectFromAll,setSelectFromAll] = useState({});
  const [SelectFromAccount,setSelectFromAccount] = useState();
  const [Name,setName] = useState();
  const [AvailableBalance,setAvailableBalance] = useState();
  const [NewLimit,setNewLimit] = useState();
  const [DailyLimit,setDailyLimit] = useState();
  const [Message,setMessage] = useState();
  const [RequstedLimit,setRequstedLimit] =useState();
  const [FailRequest,setFailRequest] =useState();
  const [SeverSideError,setSeverSideError] =useState();

useEffect( () => {    
    GetAccountsAPI();
  },[])  ;
  
const GetAccountsAPI = () =>{
  CommonAPI.FromToAccountAPI((results) =>{   
      if(results){                    
        setFromAccountList(results.data.mapAccountList?results.data.mapAccountList.filter(e=>(e.fromOrToAccount==1 && e.showByAccOpt)):null);
      }
  });
} 
  const SelectFromOnChange = (event) => {
    var passValFrom = JSON.parse(event.target.value);

    setSelectFromAll(JSON.parse(event.target.value));
    setSelectFromAccount(passValFrom.accountNo?passValFrom.accountNo:null);

    if(passValFrom){GetCurrentLimit(passValFrom.accountNo)};        
 }

const GetCurrentLimit = (AccNo)=> { 
  CommonAPI.GetCurrentTransferLimit({AccNum:AccNo},(result)=>{
    if(result){       
        setName (result.data.name);
        setAvailableBalance (result.data.availableBalance);
        setDailyLimit (result.data.dailyLimit);
        setNewLimit (result.data.dailyLimit);
        setMessage(result.data.message);       
        return result;
    }  
});
}

const PostNewLimit = ()=> { 
  CommonAPI.PostNewLimit({DailyLimit:DailyLimit,NewLimit:NewLimit,SelectFromAccount:SelectFromAccount},(result)=>{
    if(result.message==="Success"){      
      setRequstedLimit(true);    
    }else if(result.message){
      setRequstedLimit(false);
      setFailRequest(result.message)    
    }
  });
}

if(RequstedLimit){
  return (<SuccessMSG ConfirmSuccess={RequstedLimit} onHide={()=>setRequstedLimit(false)} 
  Close={()=>setRequstedLimit(false)} head="SUCCESSFULLY" head2="REQUESTED" 
  contentline1="To Activate Your new daily payment limit Please Contact 011-2301301 Then make your payments"
   />)
}else{
        return (

            <Modal
              show={props.isOpen}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title  id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>MAINTAIN</p><br/>DAILY TRANSFER LIMIT
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                
                <Form >
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={4}>
                            Account Number
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select 
                          size="sm"                         
                          className="form-h2 "
                          value={JSON.stringify(SelectFromAll)}
                          onChange={SelectFromOnChange}
                          >
                              <option value={JSON.stringify("select")}>Select</option>
                              {FromAccountList?FromAccountList.filter((e)=>e.jointAccountVisibility==true).map((listValue,index)=>{
                                 return (
                                 <option  key={index} value={JSON.stringify(listValue)}>
                                   Account Number : {listValue.accountNo} | Available Balance : LKR {parseFloat(listValue.avialableBalance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                  </option>)
                              }):
                              null
                              }                              
                          </Form.Select>
                        </Col>
                    </Form.Group>
                    {Message=="Success!"?
                    <div>
                      <Form.Group as={Row} className="mb-1" >
                          <Form.Label className="c-font" column sm={4}>
                              Holder Name
                          </Form.Label>
                          <Form.Label className="c-font" column sm={8}>
                              {Name}
                          </Form.Label>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-1" >
                          <Form.Label className="c-font" column sm={4}>
                            Available Balance
                          </Form.Label>
                          <Form.Label className="c-font" column sm={8}>
                              {parseFloat(AvailableBalance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                          </Form.Label>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-1" >
                          <Form.Label className="c-font" column sm={4}>
                            Current Daily Limit
                          </Form.Label>
                          <Form.Label className="c-font" column sm={8}>
                              {parseFloat(DailyLimit).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                          </Form.Label>
                      </Form.Group>
                    </div>
                    :null
                      }
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={4}>
                         New Daily Limit
                        </Form.Label>
                        <Col sm={8} >
                        <Form.Control 
                        value = {NewLimit}
                        maxlength='8'   
                        onChange={(text)=>setNewLimit(text.target.value)}                     
                        className="form-h2" size="sm" type="text" placeholder="New Daily Limit" />
                        </Col>
                    </Form.Group>
                    <p className='vali-txt'>{FailRequest}</p>
                </Form>
              </Modal.Body>
              <Modal.Footer className="mb-1 margintop-f2">                
                <Button onClick={()=>PostNewLimit()}    className="btn-logout" >UPDATE</Button>
              </Modal.Footer>
            </Modal>
          );
        }
    }

export default DailyTransferLimit;